import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx } from "vue"

import {useStore} from "vuex";
import {computed} from "vue";

import ButtonStrip from "@/components/UI/ButtonStrip.vue";
import ButtonPrimitive from "@/components/UI/ButtonPrimitive.vue";
import {CutoutTypes} from "@/Models/CutoutTypes";


export default /*#__PURE__*/_defineComponent({
  __name: 'CutoutType',
  setup(__props) {

const store = useStore();
const cutoutType = computed(() => store.getters.cutoutType );
const cutoutSelectorButtons = computed(() => store.getters.cutoutSelectorButtons );
const activeItemIndex = computed(() => {
	const index = cutoutSelectorButtons.value.findIndex( ( item: {
		active: boolean;
	} ) => item.active === true);

	return index === -1 ? 0 : index;
});

async function updateCutoutType( type: CutoutTypes ) {

	// Get current type
	if ( cutoutType.value === CutoutTypes.none && type !== CutoutTypes.none ) {
		store.commit("updateCutoutType", type );

		await store.dispatch("updateDefaultCutoutMeasurements");
	}

	// reset correctly when going from text to shape
	if ( cutoutType.value === CutoutTypes.text && type === CutoutTypes.shape ) {
		await store.dispatch( "resetCutouts" );
		store.commit("updateCutoutType", type );
		await store.dispatch("updateDefaultCutoutMeasurements");
	}

	if ( type === CutoutTypes.text ) {
		store.commit("updateCutoutShape", "text");
		await store.dispatch("updateDefaultCutoutMeasurements");
		await store.dispatch( "text/setDefaults", true, { root: true } );
	}

	store.commit("updateCutoutType", type );

	if( type === CutoutTypes.none ) {
		await store.dispatch( "resetCutouts" );
	}
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ButtonStrip, {
    "total-buttons": cutoutSelectorButtons.value.length,
    "buttons-per-row": 5,
    "selected-item": activeItemIndex.value
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cutoutSelectorButtons.value, (item, index) => {
        return (_openBlock(), _createBlock(ButtonPrimitive, {
          "on-click": () => updateCutoutType(item.selection),
          icon: item.icon,
          text: item.text,
          index: index,
          "is-active": item.selection === cutoutType.value
        }, null, 8, ["on-click", "icon", "text", "index", "is-active"]))
      }), 256))
    ]),
    _: 1
  }, 8, ["total-buttons", "selected-item"]))
}
}

})